export const errorColor = "red";